import React from 'react';
import { useNavigate } from '@tanstack/react-router';
import type { UserFeatureKey } from '@chatsdet/types';
import { useAuth } from '../../contexts/AuthContext';

/**
 * Route guard: renders children only when the viewer's org has `feature`
 * enabled; otherwise redirects home. Used to wrap feature-flagged routes (e.g.
 * Labs › UX Review) so direct URL access is gated, not just the nav entry.
 */
export function RequireFeature({
  feature,
  children,
}: {
  feature: UserFeatureKey;
  children: React.ReactNode;
}) {
  const { user, isLoading } = useAuth();
  const navigate = useNavigate();
  const allowed = Boolean(user?.features?.[feature]);

  React.useEffect(() => {
    if (!isLoading && !allowed) navigate({ to: '/' });
  }, [isLoading, allowed, navigate]);

  if (isLoading || !allowed) return null;
  return <>{children}</>;
}
